<template>
    <div class="data-picker">
        <div v-for="(item, index) in data" 
            :key="index" 
            :class="{'data-item':true, 'data-item-true': selectIndex == index}"
            @click="pickItemChange(index, item)"
            >{{ titleKey ? item[`${titleKey}`] : item }}</div>
    </div>
</template>
<script>
export default {
    name: 'data-picker',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        titleKey: String,
        pickIndex: {
            type: Number,
            default: -1
        },
    },
    watch: {
        pickIndex(newValue) {
            this.selectIndex = newValue
        }
    },
    data() {
        return {
            selectIndex: this.pickIndex,
        }
    },
    methods: {
        pickItemChange(index, item) {
            this.selectIndex = index
            this.$emit('changed', index, item)
        }
    }
}
</script>
<style lang="less" scoped>

.data-picker {
    background-color: @bg-color-29;
    display: inline-block;
    padding: 10px;
    border-radius: 10px;
    
    .data-item {
        min-width: 60px;
        width: 100%;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        color: @color-txt-normal;
        font-size: @font-size-normal;
        white-space: nowrap;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        &:nth-of-type(n+2) {
            margin-top: 4px;
        }
        &:hover {
            cursor: pointer;
            color: @color-txt-high;
        }
        
    }
    .data-item-true {
        color: @color-txt-high;
        background-color: @bg-color-1E;
        border-radius: 10px;
    }
}

</style>